module.exports = __webpack_public_path__ + "img/BRCA4_CD8Tex.bcbfbd51.png";